var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplay = function SvgReplay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "25px",
    viewBox: "0 0 22 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "replay-24px")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "var(--blue)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pers\\xF6nliche-Angaben-02-Jahr",
    className: "fillToggle strokeToggle",
    transform: "translate(-29.000000, -278.000000)",
    fill: "var(--blue)",
    fillRule: "nonzero",
    stroke: "var(--blue)",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "replay-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1940929,2.57142857 L10.1940929,0.698571429 C10.1940929,0.12 9.4998072,-0.162857143 9.10123577,0.248571429 L4.21552149,3.40714286 C3.95837863,3.66428571 3.95837863,4.06285714 4.21552149,4.32 L9.08837863,7.47857143 C9.4998072,7.87714286 10.1940929,7.59428571 10.1940929,7.01571429 L10.1940929,5.14285714 C14.9898072,5.14285714 18.7826643,9.54 17.7283786,14.5157143 C17.1240929,17.4342857 14.7583786,19.7871429 11.8526643,20.3914286 C7.26266434,21.3557143 3.17409291,18.2057143 2.55695006,13.95 C2.46695006,13.3328571 1.92695006,12.8571429 1.29695006,12.8571429 C0.525521486,12.8571429 -0.0916213714,13.5385714 0.0112357715,14.31 C0.808378629,19.9542857 6.18266434,24.1328571 12.2640929,22.95 C16.2755215,22.1657143 19.5026643,18.9385714 20.2869501,14.9271429 C21.5598072,8.33142857 16.5455215,2.57142857 10.1940929,2.57142857 Z",
    id: "Refresh_Icon"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replay.82e3c652.svg";
export { ForwardRef as ReactComponent };